import {
    MESSAGE_RECEIVED,
    omnichannelReducer as baseOmnichannelReducer,
    OmnichannelState
} from '@spike/omnichannel-action';
import { AnyAction } from 'redux';

export const omnichannelReducer = (state: OmnichannelState | undefined, action: AnyAction): OmnichannelState => {
    const next = baseOmnichannelReducer(state, action);

    if (action.type !== MESSAGE_RECEIVED) {
        return next;
    }

    const conversationId = action.payload.conversationId as number;
    const conversationUnreadCount = action.payload.conversationUnreadCount as number;

    return {
        ...next,
        conversations: next.conversations.map(summary =>
            summary.id === conversationId ? { ...summary, unreadCount: conversationUnreadCount } : summary
        ),
        selectedConversation:
            next.selectedConversation?.id === conversationId
                ? { ...next.selectedConversation, unreadCount: conversationUnreadCount }
                : next.selectedConversation
    };
};
